<template lang="pug">
  .root
    the-heading(:caption="caption" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        .globalCaptionStyles.localCaption {{caption}}
        .filter_block
          Keypress(:key-code="13" event="keyup" @pressed="find")
          .fields
            .item
              label Начало периода *
              .field_container
                WebiomedDatepicker(v-model="filter.start_date" :value="filter.start_date")
            .item
              label Конец периода *
              .field_container
                WebiomedDatepicker(v-model="filter.end_date" :value="filter.end_date")
            .item(v-if="this.$route.params.id !== '3'")
              label Имя учётной записи
              .field_container
                WebiomedSearchField(
                  v-model="filter.account"
                  :value="filter.account"
                  :search_by="'id'",
                  :show="'username'"
                  :api="'gate/api/v1/'"
                  :address="'accounts/'"
                  :fieldAdd="'?username__icontains='"
                  :placeholder="'Введите имя учётной записи...'"
                  :icons="'clinic-medical'",
                  :namespase="'StatisticsView'"
                  )
            .item
              label Название МО документов
              .field_container
                WebiomedSearchField(
                  v-model="filter.hospital_name"
                  :value="filter.hospital_name"
                  :search_by="'hospital_name'",
                  :show="'hospital_name'"
                  :address="'webiomedmpi/requests/hospital-names/'"
                  :fieldAdd="'?hospital_name__icontains='"
                  :placeholder="'Введите название МО...'"
                  :icons="'clinic-medical'",
                  :namespase="'StatisticsView'"
                  )
            .item(v-if="regionOptions.length")
              label Регион
              .field_container
                WebiomedSelect(:options="regionOptions" :value="filter.region" v-model="filter.region")
          .buttons(style="position: relative")
            button.find(@click="find") Рассчитать
            button.clear(@click="clear") Очистить фильтры
            //- button.clear(@click="download" :disabled="disabled" style="position: absolute; right: 0")
            //-   v-icon(name="download" scale="0.8" style="margin-right: 5px")
            //-   span Скачать
            //- button.clear(@click="printExel" :disabled="disabled" style="position: absolute; right: 0") Распечатать
        hr
        .start(v-if="startText" :class="{'errDate': errorDate === true}")
          div
            v-icon(v-if="errorDate === true" name="exclamation-circle" scale="1.7" )
            span &ensp;{{startText}}
        .load(v-if="!startText")
          .view(v-if="spinnerON")
            v-icon(name="spinner" spin scale="3" style="color: #ccc")
          .view(v-if="!spinnerON && !data.detail")
            RDResultsTable(v-if="this.$route.params.id == 1" :data="data" ref="RDResultsTable")
            QuerySourcesTable(v-if="this.$route.params.id == 2" :data="data" ref="QuerySourcesTable")
            QueryEvaluationsTable(v-if="this.$route.params.id == 3" :data="data" ref="QueryEvaluationsTable")
</template>
<script>
import TheHeading from '@/components/parts/TheHeading'
import WebiomedDatepicker from '@/components/fields/WebiomedDatepicker'
import WebiomedSearchField from '@/components/fields/WebiomedSearchField'
import WebiomedSelect from '@/components/fields/WebiomedSelect'
import breadcrumbs from '@/data/breadcrumbs/StatisticsView'
import QueryEvaluationsTable from '@/templates/QueryEvaluationsTable'
import QuerySourcesTable from '@/templates/QuerySourcesTable'
import RDResultsTable from '@/templates/RDResultsTable'
import axios from 'axios'
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    TheHeading,
    WebiomedDatepicker,
    WebiomedSearchField,
    WebiomedSelect,
    'v-icon': Icon,
    QueryEvaluationsTable,
    QuerySourcesTable,
    RDResultsTable,
    breadcrumbs,
    Keypress: () => import('vue-keypress')
  },
  beforeCreate () {
    axios
      .get('dhra/api/v2/analytics/reports/' + this.$route.params.id + '/')
      .then(values => {
        this.caption = values.data.name
        document.title = this.caption
      })
      .then(
        axios.get('gate/api/v1/accounts/get-user-regions/').then(regions => {
          regions.data.forEach(item => {
            item['id'] = item['region_id']
            item['name'] = item['region_text']
            delete item['region_id']
            delete item['region_text']
          })
          this.regionOptions = regions.data
        })
      )
      .catch(error => {
        console.log(error.response)
      })
  },
  data () {
    return {
      regionOptions: [],
      data: [],
      filter: {},
      caption: null,
      breadcrumbs,
      searchParams: new URLSearchParams(),
      startText:
        'Пожалуйста, укажите данные для расчёта и нажмите кнопку «Рассчитать»',
      disabled: true,
      spinnerON: false,
      errorDate: false
    }
  },
  methods: {
    find () {
      this.spinnerON = true
      this.disabled = true
      if (!this.filter.start_date || !this.filter.end_date) {
        this.startText =
          'Для расчёта необходимо указать дату начала и окончания периода'
        this.data = []
      } else {
        const start = this.$moment(this.filter.start_date, 'DD.MM.YYYY')
        const end = this.$moment(this.filter.end_date, 'DD.MM.YYYY')

        if (this.$moment(start).isAfter(this.$moment(end), 'days')) {
          this.startText =
            'Дата окончания периода не может быть раньше даты начала'
          this.errorDate = true
        } else {
          this.errorDate = false
          this.startText = null
          this.searchParams = new URLSearchParams()
          if (Object.keys(this.filter).length) {
            Object.keys(this.filter).forEach(key => {
              if (this.filter[key] !== null) this.searchParams.append(key, this.filter[key])
            })
          }
          axios
            .get(
              'dhra/api/v2/analytics/reports/' +
              this.$route.params.id +
              '/data/?' +
              this.searchParams
            )
            .then(values => {
              this.data = values.data
              this.disabled = false
              if (this.data.detail) {
                this.startText = this.data.detail
              }
            })
            .finally(() => (
              this.spinnerON = false
            ))
        }
      }
    },
    download () {
      // Parsing request data to search params string
      this.searchParams = new URLSearchParams()
      if (Object.keys(this.filter).length) {
        Object.keys(this.filter).forEach(key => {
          this.searchParams.append(key, this.filter[key])
        })
      }
      axios({
        url:
          'dhra/api/v2/analytics/reports/' +
          this.$route.params.id +
          '/file/?' +
          this.searchParams,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.xls')
        document.body.appendChild(link)
        link.click()
      })
    },
    clear () {
      this.filter = {}
      this.data = []
      this.disabled = true
      this.startText =
        'Пожалуйста, укажите данные для расчёта и нажмите кнопку «Рассчитать»'
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/pageGridStyles.sass"
.main_block
  min-height: 89vh
.load
  display: flex
  justify-content: center
  align-items: center
  min-height: 300px
hr
  border: 1px #ccc dotted
.start
  font-size: 18px
  display: grid
  justify-content: center
  align-content: center
  height: 200px
.view
  margin-top: 40px
.errDate
  color: #e53935
  display: flex
  align-items: center
  justify-content:  center
@media screen and (max-width: 1460px)
  .fields
    grid-template-columns: 1fr 1fr 1fr
@media screen and (max-width: 1120px)
  .container
    justify-content: left
  .fields
    grid-template-columns: 1fr 1fr 1fr
    padding-left: 10px
    padding-right: 10px
  .buttons
    margin-left: 10px
  .localCaption
    margin-left: 10px

@media screen and (max-width: 1024px)
  .fields
    grid-template-columns: 1fr 1fr

@media screen and (max-width: 690px)
  .fields
    grid-template-columns: 1fr
</style>
<style lang="sass">
.StatisticsView
  font-size: 15px
</style>
